import GraphItem from 'components/healthScoreChart/GraphItem'

const HealthScoreChart = () => {
  return <GraphItem />
}

export default HealthScoreChart
